 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Fund
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryFundFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryFundFilterForm"
                            v-model="filtersFund.fund"
                            :label="filtersFundLabel.fund"
                            :error-messages="errors.collect('filterFund')"
                            data-vv-name="filterFund"
                            :data-vv-as="filtersFundLabel.fund"
                            v-validate="'entry|max:8'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFundFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doFundFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="fundHeaders"
          :items="fundItems"
          v-bind:options.sync="paginationFund"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsFund"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.fund }}</td>
              <td>{{ row.item.fundDesc }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignFund(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { accountsFilters } from '@/mixins/accounting/accountsFilters'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      paginationFund: {
        page: 1
      }
    }
  },
  mounted() {
  },
  watch: {
    boolRefresh: function(value) {
      if (value) {
        this.doClearFundFilters()
      }
    },
    'paginationFund': function (value) {
      this.doClearFundFilters()
    }
  },
  methods: {
    closeDialog() {
      this.filtersFund.fund = ''
      this.$emit('close')
    },
    doClearFundFilters() {
      this.filtersFund.fund = ''
      this.fetchFundData()
    },
    doFundFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryFundFilterForm').then((result) => {
        if (result) {
          this.paginationFund.page = 1
          this.fetchFundData()
        }
      })
    },
    assignFund(data) {
      // Use $emit to call parent Accounts page method assignFund and pass the value
      this.$emit('assign-fund', data.fund)
      this.$emit('close')
    }
  },
  computed: {},
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    }
  },
  mixins: [TableConst.default, accountsFilters, commonAjaxMixin]
}
</script>
